import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

export const IconButtonElem = styled(FocusNode)`
  width: 50px;
  height: 50px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.4;
  border-radius: 8px;
  overflow: hidden;

  &.isFocusedLeaf {
    background: ${(props) =>
      props.theme.colors.button.focusedElem.backgroundSecondary};
    box-shadow: 0 0 0 2px
      ${(props) => props.theme.colors.button.focusedElem.border} inset;
    opacity: 1;
  }
`
